import React, { useEffect, useState } from 'react';
import { observer, inject } from 'mobx-react';
import { Redirect, useLocation, useNavigate } from '@reach/router';

import CauzeSpinner from 'components/CauzeSpinner/CauzeSpinner';
import Button from 'components/Button/Button';
import Currency from 'components/Currency/Currency';

import logo from 'assets/images/brand/cauze-logotype-accent.svg';
import desktop from 'assets/images/illustrations/find-nonprofit.png';
import mobile from 'assets/images/illustrations/add-to-account.png';
import useDashboardStore from 'stores/DashboardStore';
import useReloadableGiftingToken from 'hooks/useReloadableGiftingToken';

const QRGiftConfirmationView = ({ donationLandingStore, authStore }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setProps } = useDashboardStore();
  const [token, setToken] = useState();
  const { reloadableToken, loading } = useReloadableGiftingToken({
    token,
  });

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    if (urlParams.has('qr')) {
      setToken(urlParams.get('qr'));
    }
  }, [location]);

  useEffect(() => {
    setProps({
      noSidebar: true,
      navbarProps: {
        hideLoginPrompt: true,
      },
    });
  }, []);

  let content = <></>;

  if (!token && !loading) {
    content = (
      <div className="gift-landing flex-column">
        <img src={logo} className="app-logo header-margin" alt="Cauze" />
        <div className="flex-column flex-align-center">
          bad or illegal token
        </div>
      </div>
    );
  }

  if (!reloadableToken && !loading && token) {
    return <Redirect to={`/redeem/qr/${token}`} />;
  }

  if (token) {
    content = (
      <div className="gift-landing flex-column">
        <img src={logo} className="app-logo header-margin" alt="Cauze" />
        {donationLandingStore.loadingGiftData || loading ? (
          <CauzeSpinner fullscreen />
        ) : (
          <div className="flex-column flex-align-center">
            <div className="title">Welcome to Cauze 👋</div>
            <p className="body-text text-align-center">
              Please select how would you like to proceed <br /> with your{' '}
              <Currency amount={reloadableToken?.gift.amount ?? 0} /> Gift Card.
            </p>
            <div className="columns gift-select-columns">
              <a
                href="/donate" className="column donate-now" onClick={(e) => {
                  e.preventDefault();

                  donationLandingStore
                    .loadGiftData({
                      token: reloadableToken?.userToken?.token,
                    })
                    .then(() => {
                      navigate('/donate');
                    });
                }}>
                <div className="flex-column flex-expand">
                  <img className="gift-select-image" src={desktop} />
                  <div className="flex-row flex-align-center">
                    <div className="flex-column flex-expand">
                      <div className="title">Donate Now</div>
                      <p>Select from list of 1M+ nonprofits</p>
                    </div>
                    <Button className="landing-button">Select Charity</Button>
                  </div>
                </div>
              </a>
              <a
                href={authStore.isAuthenticated ? '/donate' : '/login'}
                className="column add-to-account"
                onClick={(e) => {
                  e.preventDefault();

                  donationLandingStore
                    .loadGiftData({
                      token: reloadableToken?.userToken?.token,
                    })
                    .then(() => {
                      if (authStore.isAuthenticated) {
                        navigate('/donate');
                      } else {
                        navigate('/login');
                      }
                    });
                }}
              >
                <div className="flex-column flex-expand">
                  <img className="gift-select-image" src={mobile} />
                  <div className="flex-row flex-align-center">
                    <div className="flex-column flex-expand">
                      <div className="title">Add to Cauze Account</div>
                      <p>
                        Don’t have one? <br />
                        Create one now
                      </p>
                    </div>
                    <Button className="landing-button">Add to Account</Button>
                  </div>
                </div>
              </a>
            </div>
          </div>
        )}
      </div>
    );
  }

  if (reloadableToken?.currentEntityIsOwner) {
    content = (
      <div className="gift-landing flex-column">
        <img src={logo} className="app-logo header-margin" alt="Cauze" />
        <div className="flex-column flex-align-center">
          You are the owner of this gift.
        </div>
      </div>
    );
  }

  return content;
};

export default inject(
  'donationLandingStore',
  'authStore',
)(observer(QRGiftConfirmationView));
